import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Header({ language, setLanguage }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Mise à jour du titre et métadonnées en fonction de la langue
    const pageTitles = {
      ar: 'معالم الهداية في حكم الأولياء الصالحين',
      en: 'Wisdom of the Righteous and the Awliya',
      fr: 'Guidance dans les sagesses des Saints'
    };
    document.title = pageTitles[language] || pageTitles.ar;

    const updateMetaTag = (name, content) => {
      const tag = document.querySelector(`meta[name="${name}"]`);
      if (tag) tag.setAttribute('content', content);
    };

    const descriptions = {
      ar: 'اكتشف أعمق الحكم والأسرار الربانية من أقوال الأولياء والعارفين',
      en: 'Discover deep divine wisdom from the sayings of saints and people of God.',
      fr: 'Découvrez la sagesse divine profonde des paroles des saints et des gens de Dieu.'
    };
    updateMetaTag('description', descriptions[language] || descriptions.ar);

    const updateOgTag = (property, content) => {
      const tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) tag.setAttribute('content', content);
    };
    updateOgTag('og:title', pageTitles[language] || pageTitles.ar);
  }, [language]);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleScrollToSubmit = (e) => {
    e.preventDefault();
    const targetId = 'submit';
    const currentPath = location.pathname;

    if (currentPath === '/') {
      const submitSection = document.getElementById(targetId);
      if (submitSection) {
        submitSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const submitSection = document.getElementById(targetId);
        if (submitSection) {
          submitSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    setLanguage(newLanguage);
  };

  const translations = {
    logo: {
      ar: 'معالم الهداية في حكم الأولياء الصالحين',
      en: 'Wisdom of the Righteous and the Awliya',
      fr: 'Guidance dans les sagesses des Saints'
    },
    menu: {
      wisdom: {
        ar: 'الحكم',
        en: 'Wisdom',
        fr: 'Sagesses'
      },
      about: {
        ar: 'عن الموقع',
        en: 'About',
        fr: 'À propos'
      },
      blog: {
        ar: 'مقالات',
        en: 'Blog',
        fr: 'Articles'
      },
      addWisdom: {
        ar: 'إضافة حكمة',
        en: 'Add Wisdom',
        fr: 'Ajouter une sagesse'
      }
    }
  };

  return (
    <header>
      <nav className="navbar">
        <div className="logo">
          <a className="logo-button" href="/">
            <p className={['en', 'fr'].includes(language) ? 'english-title' : ''}>
              {translations.logo[language] || translations.logo.ar}
            </p>
          </a>
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          <div className={`burger-bar ${isOpen ? 'open' : ''}`}></div>
          <div className={`burger-bar ${isOpen ? 'open' : ''}`}></div>
          <div className={`burger-bar ${isOpen ? 'open' : ''}`}></div>
        </div>
        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <a href="/" className={['en', 'fr'].includes(language) ? 'english-title-nav' : ''}>
            {translations.menu.wisdom[language] || translations.menu.wisdom.ar}
          </a>
          <a href="/about" className={['en', 'fr'].includes(language) ? 'english-title-nav' : ''}>
            {translations.menu.about[language] || translations.menu.about.ar}
          </a>
          <a href="/blog" className={['en', 'fr'].includes(language) ? 'english-title-nav' : ''}>
            {translations.menu.blog[language] || translations.menu.blog.ar}
          </a>

          <button
            onClick={handleScrollToSubmit}
            className={['en', 'fr'].includes(language) ? 'english-title-nav' : ''}
          >
            {translations.menu.addWisdom[language] || translations.menu.addWisdom.ar}
          </button>
          <select
            value={language}
            onChange={handleLanguageChange}
            className="language-selector"
          >
            <option value="ar">العربية</option>
            <option value="en">English</option>
            <option value="fr">Français</option>
          </select>
        </div>
      </nav>
    </header>
  );
}

export default Header;